import { render, staticRenderFns } from "./HtDeleteButton.vue?vue&type=template&id=2da0e068&"
import script from "./HtDeleteButton.vue?vue&type=script&lang=js&"
export * from "./HtDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports